import axios from 'axios';


const urlBacken = process.env.REACT_APP_URLBACKEND

const apiBacken = axios.create({
  baseURL: urlBacken,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para adjuntar el token en cada solicitud
apiBacken.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

//ajuste del interceptor para manejar el error 401
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

apiBacken.interceptors.response.use(
  response => response,
  async (error) => {
    const originalRequest = error.config;

    // Verifica si es error de token inválido
    const shouldRefresh =
      error.response &&
      error.response.data &&
      error.response.data.code === 'token_not_valid';

    if (shouldRefresh && !originalRequest._retry) {
      originalRequest._retry = true;

      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return apiBacken(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      isRefreshing = true;

      const refresh = localStorage.getItem('refresh');
      try {
        const res = await apiBacken.post('/api/token/refresh/', { refresh });
        const newToken = res.data.access;
        localStorage.setItem('access', newToken);
        apiBacken.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
        processQueue(null, newToken);
        return apiBacken(originalRequest);
      } catch (err) {
        processQueue(err, null);
        // Aquí puedes hacer logout, redirigir, etc.
        return Promise.reject(err);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);


export function postLogin(username, password) {

  var url = urlBacken
  
  return apiBacken.post(url+'/api/token/', {
    username, password
  })
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}
export function postLoginUsuarioPruebas() {

  var url = urlBacken
  
  return apiBacken.post(url+'/api/token/', {
    username: 'a@gmail.com', password: 'a'
  })
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function obtenerEventos() {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.get(url+'/eventsbyestablecimientoempleado/',  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function postRegistro(form) {

  var url = urlBacken
  
  return apiBacken.post(url+'/crearestablecimientos/', 
    form
  )
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function postCrearEvento(form) {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.post(url+'/crearevento/', 
    form, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function postCrearProducto(form) {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.post(url+'/createproduct/', 
    form, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function getPerfilEstablecimiento() {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.get(url+'/infoestableciminetopc/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}
export function DeleteProducto(form) {

  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.delete(url+'/deleteproduct/', 
     {
      data: form,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}

export function GettaInveario(form) {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.get(url+'/obtenerproductospc/', 
    form, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });

}

export function songList(formId) {
  var url = urlBacken
  return apiBacken.post(url+'/obtenerlistacancion/', 
    formId  
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}

export function CambiarEstadoCancion(formId) {
  var url = urlBacken
  return apiBacken.put(url+'/updatelistacancion/', 
    formId  
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}

export function createlistacancion(cuerpo, token) {
  var url = urlBacken
  return apiBacken.post(url+'/createlistacancion/', 
    cuerpo, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}
export function updateestablecimiento(cuerpo, token) {
  var url = urlBacken
  return apiBacken.put(url+'/updateestablecimiento/', 
    cuerpo, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}
export function enviaCodigo(cuerpo) {
  var url = urlBacken
  return apiBacken.post(url+'/codigocontraseña/', 
    cuerpo
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}
export function actualizarCon(cuerpo) {
  var url = urlBacken
  return apiBacken.post(url+'/actualizarontraseña/', 
    cuerpo
  )
  .then((response) => {
    // console.log('Respuesta del servidor:', response);
    if (!response.status || response.status !== 200) {
      throw new Error('Error en la solicitud');
    }
    return response.data;
  })
  .catch((error) => {
    console.error('Error:', error);
    throw error;
  });
}

export function getUserInfo() {
  var url = urlBacken
  const token = localStorage.getItem("access");
  
  return apiBacken.get(url+'/userinfo/', {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      // console.log('Respuesta del servidor:', response);
      if (!response.status || response.status !== 200) {
        throw new Error('Error en la solicitud');
      }
      return response.data;
    })
    .catch((error) => {
      console.error('Error:', error);
      throw error;
    });
}